<template>
  <div class="view pa24">
    <el-form :model="serchParams" class="demo-form-inline" :inline="true">
      <el-row style="padding-top: 20px;">
        <el-form-item label=""  label-position="left" class="fromItem" prop="name">
          <el-input v-model="serchParams.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-row>
    </el-form>
    <div class="d-flex">
        <el-button class="ma" type="primary" @click="handleAddDealer('add')">+添加部门</el-button>
    </div>
    <commonTable
      :tableData="tableData"
      :total="total"
      :currentPage="pageNum"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:table>

        <el-table-column
          prop="name"
          align="center"
          label="部门名称"
        />
        <el-table-column
          prop="createTime"
          align="center"
          label="创建时间"
        />
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editDealar(scope.row)">编辑</el-button>
             <el-button type="text" style="color: red" @click="deleteDealar(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>

    <AddDealerDialog ref="addDealerDialog" @getList="getList"></AddDealerDialog>
  </div>
</template>

<script>
import AddDealerDialog from './components/AddDealerDialog'
import commonTable from "@/components/common/commonTable";
import { fetchDepList, fetchDelDept } from '@/api/customPageClass.js'

export default {
  name: "dealerList",
  components: {
    commonTable,
    AddDealerDialog,
  },
  data() {
    return {
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
      serchParams:{
        name:''
      }
    };
  },
  created() {
    this.getList()
  },
  methods: {
    search() {
      this.pageNum = 1
      this.getList()
    },
    resetSearch() {
      this.serchParams.name = ''
      this.pageNum = 1
      this.getList()
    },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      handleAddDealer(type, id) {
          this.$refs.addDealerDialog.openDialog(type, id)
      },
      getList() {
        let params={
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.serchParams
        }
        fetchDepList(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
      editDealar(data) {
        this.$refs.addDealerDialog.openDialog('edit', data)
      },
      deleteDealar(data) {
        let params={
          departmentId: data.departmentId
        }
        this.$confirm('此操作将永久删除该部门, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          fetchDelDept(JSON.stringify(params)).then(res => {
            if(res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      }
  }
}
</script>

<style lang="scss" scoped></style>

